<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    checked: { type: [Boolean, String, Object] },
  },
  computed: {
    wrapperClass() {
      return {
        'lego-validator--error': this.hasError === true,
        'lego-validator--valid': this.showValid && this.hasError === false,
        'lego-validator--shake': this.shake,
        'lego-radio-wrapper--vertical': this.vertical,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.lego-radio-wrapper {
  .lego-radio--medium + .lego-radio--medium {
    margin-left: $lego-checkbox-wrapper__margin-left--medium;
  }
}

.lego-radio-wrapper--vertical {
  .lego-radio + .lego-radio {
    margin-top: $lego-checkbox-wrapper__vertical__margin;
    margin-left: 0;
  }

  .lego-radio {
    width: 100%;
  }
}
</style>
